import React from 'react';

import '../navbar/navbar.css';
import Navbar from '../navbar/navbar';

import '../gallerypage/gallery.css';
import Gallerypage from '../gallerypage/gallery';

import '../navbar/footer.css';
import Footer from '../navbar/footer';
import Gallerymenu from '../gallerypage/gallerymenu';
import Galleryintro from '../gallerypage/galleryintro';
import Gallerygrid from '../gallerypage/gallerygrid';




function Gallery() {
    return (
        <>
            <Navbar />

            <Gallerymenu />

            <Gallerygrid />

            <Footer />

        </>
    )
}

export default Gallery;